import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '../card';
import { SetupItem } from './SetupItem';
import { setupItems, SetupItem as SetupItemType } from './setup-config';

interface FilteredFinishYourSetupSectionProps {
  /**
   * Optional array of setup item IDs to filter and display
   * If not provided, shows all setup items
   */
  filterItemIds?: string[];
}

/**
 * Enhanced version of FinishYourSetupSection that can filter items
 * to show only incomplete tasks based on the admin's current setup status
 */
export const FilteredFinishYourSetupSection: React.FC<FilteredFinishYourSetupSectionProps> = ({ 
  filterItemIds 
}) => {
  const { t } = useTranslation();

  // Filter items if filterItemIds is provided, otherwise show all
  const itemsToDisplay: SetupItemType[] = filterItemIds
    ? setupItems.filter(item => filterItemIds.includes(item.id))
    : setupItems;

  // If no items to display after filtering, don't render anything
  if (itemsToDisplay.length === 0) {
    return null;
  }

  return (
    <section className="w-full">
      {/* Header */}
      <header className="mb-4">
        <h2 className="font-cal-sans text-xl text-[#004232] dark:text-white">
          {t('finishSetup.title')}
        </h2>
      </header>

      {/* Setup Items Card */}
      <Card className="bg-white dark:bg-card-dark border border-gray-200 dark:border-border-dark rounded-2xl">
        <div className="flex flex-col">
          {itemsToDisplay.map((item, index) => (
            <SetupItem
              key={item.id}
              item={item}
              isLast={index === itemsToDisplay.length - 1}
            />
          ))}
        </div>
      </Card>
    </section>
  );
};

